<template>
    <div>
      <router-view/>
    </div>
</template>

<script>

  export default {
    name: '',
    props: [''],
    data () {
      return {};
    },
    methods: {}
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/finance/index.vue